<template>
  <div class="soar-container">
    <component :is="form"></component>
  </div>
</template>

<script setup>
import IssueQrCodeForm from '@/views/addl-service-form/issue-qr-code/index.vue'
import SearchForAppointmentForm from '@/views/addl-service-form/search-for-appointment/index.vue'
import UsaRegisterArrivalsForm from '@/views/addl-service-form/usa-register-arrivals/index.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const formMap = {
  'issue-qr-code': IssueQrCodeForm,
  'usa-register-arrivals': UsaRegisterArrivalsForm,
  'search-for-appointment': SearchForAppointmentForm
}

const route = useRoute()

const form = computed(() => {
  const { serviceSlug } = route.params

  if (Object.keys(formMap).includes(serviceSlug)) {
    return formMap[serviceSlug]
  }

  return null
})
</script>

<style lang="scss" scoped></style>
